const Modules = {};
const requireModule = require.context('../modules', true, /index+\.js$/);

requireModule.keys().forEach((v) => {
    let module = requireModule(v).default;
    Modules[module.type] = module;
});

export default Modules;
